<template>
  <div>
    <b-row>
      <b-col cols="6">
        <basic-portlet compact>
          <div class="p-4">
            <storage-limit-progress-bar />
          </div>
        </basic-portlet>
      </b-col>
    </b-row>
    <storage-table title="Storage" :portlet-expanded="true" :portlet-locked="true" />
    <pending-uploads-table v-perms="['third_party_uploader']" />
  </div>
</template>

<script>
import StorageTable from 'VuePartials/StorageTable';
import PendingUploadsTable from "VuePartials/App/ThirdPartyUploader/PendingUploadsTable";
import StorageLimitProgressBar from "VuePartials/StorageLimitProgressBar";

export default {
  components: {
    StorageTable,
    PendingUploadsTable,
    StorageLimitProgressBar,
  },
};
</script>

<style lang="scss" scoped>
@use "~AssetsSass/_variables" as *;

.trim-padding {
  padding: 0 !important;
}

.kt-title-mimick {
	display: flex;
	font-size: 1.1rem;
	font-weight: 500;
  margin-left: -10px;
}
</style>
